module.exports = __webpack_public_path__ + "static/media/LogoPrata.90347665.png";